// Vue+Vuex importieren
import Vue from 'vue';
import Vuex from 'vuex';
import store from './stores/store'
Vue.use(Vuex);

// Plugins laden
import './plugins/fontawesome';
import './plugins/element.js';

// App laden und Router setzen
import App from './App.vue';
import router from './router';
import core from '@/core/Core';
core.setRouter(router);
global.core = core;

// Dependencies laden
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */ )
import VeeValidate from 'vee-validate';
import ValidationDict from './assets/dictionary/validation';
Vue.use(VeeValidate, {
    locale: 'de',
    dictionary: ValidationDict,
    fieldsBagName: 'vfields'
});

// CSS laden
import 'swiper/dist/css/swiper.css'
import './assets/global.scss'


Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')